module.exports = __webpack_public_path__ + "static/4-f8a866d111012d674c9be182f3e86ebd.jpg";